import { Text } from '@wartek-id/text-v1'

import { PANDUAN_ROTASI_MUTASI_URL } from 'app/KinerjaPSPegawaiPage/constants/panduan'
import CardNotificationBase from './CardNotificationBase'

import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'

const CardNotificationRotasiMutasiPS = (
  cardProps: CardNotificationBaseProps
) => {
  return (
    <CardNotificationBase {...cardProps}>
      <div className="mt-6">
        <a
          href={PANDUAN_ROTASI_MUTASI_URL}
          target="_blank"
          rel="noreferrer noopenner"
        >
          <Text
            color="informational"
            variant="body-sm"
            className="!font-semibold cursor-pointer"
          >
            Ke Pusat Bantuan
          </Text>
        </a>
      </div>
    </CardNotificationBase>
  )
}

export default CardNotificationRotasiMutasiPS
